import { render, staticRenderFns } from "./ComplexBewerken.vue?vue&type=template&id=441eb6cc"
import script from "./ComplexBewerken.vue?vue&type=script&lang=js"
export * from "./ComplexBewerken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports